import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['template', 'actions']

  add(e) {
    e.preventDefault()

    const content = this.templateTarget.innerHTML.replace(
      /NEW_MENU_ITEM/g,
      new Date().getTime()
    )

    this.actionsTarget.insertAdjacentHTML('beforebegin', content)
  }

  remove(e) {
    e.preventDefault()

    const wrapper = e.target.closest('.nested-fields')

    if (wrapper.dataset.newRecord === 'true') {
      wrapper.remove()
    } else {
      wrapper.querySelector("input[name*='_destroy']").value = 1
      wrapper.style.display = 'none'
    }
  }
}
